import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  const executeRecaptcha = async (action: string) => {
    try {
      return await nuxtApp.$recaptcha.execute(action)
    }
    catch (error) {
      console.error('Erro ao executar reCAPTCHA:', error)
      return null
    }
  }

  return {
    provide: {
      recaptcha: {
        execute: executeRecaptcha,
      },
    },
  }
})
